module.exports = __webpack_public_path__ + "static/media/trial2.2a935df6.mp3";